/* tslint:disable */
/* eslint-disable */
/**
 * Vocalise.API.Web
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  FAnonymousType124,
  FAnonymousType176,
  FAnonymousType181,
  SessionDTO,
  SessionDefinitionDTO,
} from '../models/index';
import {
    FAnonymousType124FromJSON,
    FAnonymousType124ToJSON,
    FAnonymousType176FromJSON,
    FAnonymousType176ToJSON,
    FAnonymousType181FromJSON,
    FAnonymousType181ToJSON,
    SessionDTOFromJSON,
    SessionDTOToJSON,
    SessionDefinitionDTOFromJSON,
    SessionDefinitionDTOToJSON,
} from '../models/index';

export interface ApiSessionDefinitionIdGetRequest {
    id: number;
    languageCode?: string;
}

export interface ApiSessionIdAbortPostRequest {
    id: number;
}

export interface ApiSessionIdEndPostRequest {
    id: number;
    sessionDTO: SessionDTO;
}

export interface ApiSessionIdGetRequest {
    id: number;
}

export interface ApiSessionStartPostRequest {
    definitionId: number;
}

/**
 * 
 */
export class SessionApi extends runtime.BaseAPI {

    /**
     */
    async apiSessionDefinitionIdGetRaw(requestParameters: ApiSessionDefinitionIdGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<SessionDefinitionDTO>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling apiSessionDefinitionIdGet().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['languageCode'] != null) {
            queryParameters['languageCode'] = requestParameters['languageCode'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/api/session/definition/{id}`;
        urlPath = urlPath.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => SessionDefinitionDTOFromJSON(jsonValue));
    }

    /**
     */
    async apiSessionDefinitionIdGet(requestParameters: ApiSessionDefinitionIdGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<SessionDefinitionDTO> {
        const response = await this.apiSessionDefinitionIdGetRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async apiSessionGetRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<FAnonymousType124>>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/api/session`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(FAnonymousType124FromJSON));
    }

    /**
     */
    async apiSessionGet(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<FAnonymousType124>> {
        const response = await this.apiSessionGetRaw(initOverrides);
        return await response.value();
    }

    /**
     */
    async apiSessionIdAbortPostRaw(requestParameters: ApiSessionIdAbortPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling apiSessionIdAbortPost().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/api/session/{id}/Abort`;
        urlPath = urlPath.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id'])));

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async apiSessionIdAbortPost(requestParameters: ApiSessionIdAbortPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.apiSessionIdAbortPostRaw(requestParameters, initOverrides);
    }

    /**
     */
    async apiSessionIdEndPostRaw(requestParameters: ApiSessionIdEndPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling apiSessionIdEndPost().'
            );
        }

        if (requestParameters['sessionDTO'] == null) {
            throw new runtime.RequiredError(
                'sessionDTO',
                'Required parameter "sessionDTO" was null or undefined when calling apiSessionIdEndPost().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/api/session/{id}/End`;
        urlPath = urlPath.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id'])));

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: SessionDTOToJSON(requestParameters['sessionDTO']),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async apiSessionIdEndPost(requestParameters: ApiSessionIdEndPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.apiSessionIdEndPostRaw(requestParameters, initOverrides);
    }

    /**
     */
    async apiSessionIdGetRaw(requestParameters: ApiSessionIdGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<FAnonymousType176>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling apiSessionIdGet().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/api/session/{id}`;
        urlPath = urlPath.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => FAnonymousType176FromJSON(jsonValue));
    }

    /**
     */
    async apiSessionIdGet(requestParameters: ApiSessionIdGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<FAnonymousType176> {
        const response = await this.apiSessionIdGetRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async apiSessionStartPostRaw(requestParameters: ApiSessionStartPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<FAnonymousType181>> {
        if (requestParameters['definitionId'] == null) {
            throw new runtime.RequiredError(
                'definitionId',
                'Required parameter "definitionId" was null or undefined when calling apiSessionStartPost().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['definitionId'] != null) {
            queryParameters['definitionId'] = requestParameters['definitionId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/api/session/Start`;

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => FAnonymousType181FromJSON(jsonValue));
    }

    /**
     */
    async apiSessionStartPost(requestParameters: ApiSessionStartPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<FAnonymousType181> {
        const response = await this.apiSessionStartPostRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
